import React from "react";
import styled from "styled-components";

import { motion } from "framer-motion";

const ModalBackdrop = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
`;

const ModalImg = styled(motion.img)`
  display: block;
  max-width: 60%;
  max-height: 80%;
  margin: 6rem auto;
  box-shadow: 3px 5px 7px rgba(0, 0, 0, 0.5);
  border: 3px solid white;
`;
const Modal = (props) => {
  const handleClick = (event) => {
    // jezeli klikniety event nie zawiera klasy img to uzyj funkjci przekazanej w props z App.js setSelectedImg która zawiera state selectedImg na podstawie którego warunkowo renderuje sie modal i ustaw na null
    if (!event.target.classList.contains("img")) {
      props.setSelectedImg(null);
    }
  };

  return (
    <ModalBackdrop
      onClick={handleClick}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <ModalImg
        src={props.selectedImg}
        alt="modal pic"
        className="img"
        initial={{ y: "-100vh" }}
        animate={{ y: 0 }}
      />
    </ModalBackdrop>
  );
};

export default Modal;
